import {
  AccountBalanceWalletOutlined,
  ApartmentOutlined,
} from '@mui/icons-material';
import Card from '@/components/Card/Card';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function TangoPage() {
  const { t } = useTranslation();

  const style = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px',
  };
  return (
    <div style={{ display: 'flex', gap: '20px' }}>
      <Link style={{ width: '100%' }} to={'/admin/createTangoGroup'}>
        <Card style={style}>
          <ApartmentOutlined style={{ fontSize: '100px' }} />
          <h1>{t('tangoManagement.createTangoGroup.title')}</h1>
          <p>{t('tangoManagement.createTangoGroup.description')}</p>
        </Card>
      </Link>
      <Link style={{ width: '100%' }} to={'/admin/createTangoAccount'}>
        <Card style={style}>
          <AccountBalanceWalletOutlined style={{ fontSize: '100px' }} />
          <h1>{t('tangoManagement.createTangoAccount.title')}</h1>
          <p>{t('tangoManagement.createTangoAccount.description')}</p>
        </Card>
      </Link>
    </div>
  );
}
